import { mapState, mapActions } from 'vuex';

export default  {	
	data () {
		return { 
			user: { email: '', password: ''}
		}
	},
	computed: { 
	  ...mapState({
		  dataGet       : state => state.crudStore.dataGet, 
	  })   
	},
	methods: {
	  ...mapActions({    
		  login:     'authStore/login',  
	  })
	}
}
